import _ from 'lodash';

let unsubscribeFromWorkbook: (() => void)[] = [];
let unsubscribeFromWorkstepChannel = _.noop;
let unsubscribeFromReportUpdatesChannel = _.noop;
export let unsubscribeFromLockingChannel: () => void = _.noop;

export function cleanupOnUnload() {
  unsubscribeFromWorkbook.forEach((fn) => fn());
  unsubscribeFromWorkstepChannel();
  unsubscribeFromReportUpdatesChannel();
  unsubscribeFromLockingChannel();
}

export function setUnsubscribeFromLockingChannel(functionDef: () => void) {
  unsubscribeFromLockingChannel = functionDef;
}

export function setUnsubscribeFromWorkbook(functionDefs: (() => void)[]) {
  unsubscribeFromWorkbook = functionDefs;
}

export function setUnsubscribeFromWorkstepChannel(functionDef: () => void) {
  unsubscribeFromWorkstepChannel = functionDef;
}

export function setUnsubscribeFromReportUpdatesChannel(functionDef: () => void) {
  unsubscribeFromReportUpdatesChannel = functionDef;
}
